import { TodayMeetingDetails } from '@components/todayMeetingDetails/todayMeetingDetailsPage';
import { ReactElement } from 'react';
import '@assets/styles/pages/today-meeting-details.scss';

export const TodayMeetingDetailsPage = (): ReactElement => {
	return <TodayMeetingDetails />;
};
